module.exports = __webpack_public_path__ + "img/excellence.6e812c38.jpg";